import { render, staticRenderFns } from "./Pk_list.vue?vue&type=template&id=aae3758c&scoped=true&"
import script from "./Pk_list.vue?vue&type=script&lang=js&"
export * from "./Pk_list.vue?vue&type=script&lang=js&"
import style0 from "./Pk_list.vue?vue&type=style&index=0&id=aae3758c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae3758c",
  null
  
)

export default component.exports